import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Icon } from 'rsuite';

import { AvatarGenerator } from './generator';

function AvatarComponent({ name, shape, mt, ...props }) {
  const getAltName = name => {
    return name
      .split(' ')
      .map(n => n[0])
      .splice(0, 2)
      .join('')
      .toUpperCase();
  };

  const avatarGenerator = new AvatarGenerator();

  return (
    <Avatar
      {...props}
      src={avatarGenerator.generateRandomAvatar(shape, name)}
      circle
      style={{ backgroundColor: '#fff', marginTop: mt ? mt : '-5px' }}>
      {name ? getAltName(name) : <Icon style={{ fontSize: '20px' }} icon="user" />}
    </Avatar>
  );
}

AvatarComponent.propTypes = {
  shape: PropTypes.oneOf(['Circle', 'Transparent']),
  name: PropTypes.string,
};

export default AvatarComponent;
